module.exports = "<app-create-agency-form></app-create-agency-form>\r\n<div *ngIf=\"formType == 'modifyAgency'\">\r\n\t<app-agent-grid></app-agent-grid>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency.component.html
// module id = ../../../../../src/app/create-agency/create-agency.component.html
// module chunks = 1